(function() {

  'use strict';

  function prazo() {
    return function(encomenda) {

      if (!encomenda || !encomenda.prazoMaximo || !encomenda.prazoMinimo) {
        return 'sem prazo!'
      }
      if (encomenda.prazoMaximo == encomenda.prazoMinimo) {
        return encomenda.prazoMaximo < 2 ? encomenda.prazoMaximo + ' dia útil' : encomenda.prazoMaximo + ' dias úteis';
      } else {
        return encomenda.prazoMaximo < 2 ? encomenda.prazoMinimo + '-' + encomenda.prazoMaximo + ' dia útil' : encomenda.prazoMinimo + '-' + encomenda.prazoMaximo + ' dias úteis';
      }
    };

  };

  angular
    .module('mandaeApp')
    .filter('prazo', prazo);

}());
